module.exports = __webpack_public_path__ + "static/media/fs_truman-light-webfont.2918fe88.woff2";